var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("span", [_vm._v("文章管理")]),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.onAdd }
                },
                [_vm._v("新增文章")]
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20, type: "flex", align: "middle" } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-size": "14px", color: "#606266" } },
                    [_vm._v("频道：")]
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { placeholder: "全部", clearable: "" },
                      on: { change: _vm.loadArticleList },
                      model: {
                        value: _vm.search.channel_id,
                        callback: function($$v) {
                          _vm.$set(_vm.search, "channel_id", $$v)
                        },
                        expression: "search.channel_id"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "全部", value: "" } }),
                      _vm._l(_vm.channelOptions, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-size": "14px", color: "#606266" } },
                    [_vm._v("状态：")]
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { placeholder: "全部", clearable: "" },
                      on: { change: _vm.loadArticleList },
                      model: {
                        value: _vm.search.status,
                        callback: function($$v) {
                          _vm.$set(_vm.search, "status", $$v)
                        },
                        expression: "search.status"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "全部", value: "" } }),
                      _c("el-option", { attrs: { label: "上架", value: 1 } }),
                      _c("el-option", { attrs: { label: "下架", value: 0 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-size": "14px", color: "#606266" } },
                    [_vm._v("标题：")]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "70%" },
                    attrs: { placeholder: "请输入文章标题", clearable: "" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loadArticleList($event)
                      }
                    },
                    model: {
                      value: _vm.search.title,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "title", $$v)
                      },
                      expression: "search.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "text-align": "right" }, attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.loadArticleList }
                    },
                    [_vm._v("搜索")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.onArticleReset }
                    },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.onTabClick },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "文章列表", name: "article" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.articleLoading,
                          expression: "articleLoading"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.articleData,
                        border: "",
                        "header-cell-style": {
                          backgroundColor: "#F5F7FA",
                          color: "#2C3E50"
                        }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "id", label: "ID", width: "60" }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "title",
                          label: "标题",
                          "min-width": "180",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "channel_name",
                          label: "频道",
                          width: "100"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "封面", width: "80", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.cover
                                  ? _c("el-image", {
                                      staticStyle: {
                                        width: "50px",
                                        height: "36px",
                                        "border-radius": "4px"
                                      },
                                      attrs: {
                                        src: scope.row.cover,
                                        fit: "cover",
                                        "preview-src-list": [scope.row.cover]
                                      }
                                    })
                                  : _c(
                                      "span",
                                      { staticStyle: { color: "#909399" } },
                                      [_vm._v("无")]
                                    )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "is_recommend",
                          label: "推荐",
                          width: "70",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: scope.row.is_recommend
                                        ? "warning"
                                        : "info",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.is_recommend ? "是" : "否"
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "pv", label: "PV", width: "70" }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "like_count",
                          label: "点赞",
                          width: "70"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "share_count",
                          label: "分享",
                          width: "70"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          label: "状态",
                          width: "70",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: scope.row.status
                                        ? "success"
                                        : "danger",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(scope.row.status ? "上架" : "下架")
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sort",
                          label: "排序",
                          width: "70",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "add_time",
                          label: "添加时间",
                          width: "160"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "150",
                          fixed: "right",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onArticleEdit(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onArticleDelete(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "20px",
                      "text-align": "right"
                    },
                    attrs: {
                      "current-page": _vm.articlePage,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.articleSize,
                      total: _vm.articleTotal,
                      layout: "total, sizes, prev, pager, next, jumper"
                    },
                    on: {
                      "size-change": _vm.onArticleSizeChange,
                      "current-change": _vm.onArticlePageChange
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "频道管理", name: "channel" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-bottom": "15px" },
                      attrs: {
                        type: "primary",
                        icon: "el-icon-plus",
                        size: "small"
                      },
                      on: { click: _vm.onChannelAdd }
                    },
                    [_vm._v("新增频道")]
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.channelLoading,
                          expression: "channelLoading"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.channelData,
                        border: "",
                        "header-cell-style": {
                          backgroundColor: "#F5F7FA",
                          color: "#2C3E50"
                        }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "id", label: "ID", width: "60" }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "频道名称",
                          "min-width": "150"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sort",
                          label: "排序",
                          width: "80",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "is_show",
                          label: "显示",
                          width: "80",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: scope.row.is_show
                                        ? "success"
                                        : "info",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.is_show ? "显示" : "隐藏"
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "is_recommend",
                          label: "推荐频道",
                          width: "90",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: scope.row.is_recommend
                                        ? "warning"
                                        : "info",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.is_recommend ? "是" : "否"
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "add_time",
                          label: "添加时间",
                          width: "160"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "150",
                          fixed: "right",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onChannelEdit(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onChannelDelete(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "20px",
                      "text-align": "right"
                    },
                    attrs: {
                      "current-page": _vm.channelPage,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.channelSize,
                      total: _vm.channelTotal,
                      layout: "total, sizes, prev, pager, next, jumper"
                    },
                    on: {
                      "size-change": _vm.onChannelSizeChange,
                      "current-change": _vm.onChannelPageChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.articleForm.id ? "编辑文章" : "新增文章",
            visible: _vm.articleDialogVisible,
            width: "750px",
            "append-to-body": true,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.articleDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "max-height": "70vh",
                "overflow-y": "auto",
                padding: "10px 20px"
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "articleForm",
                  attrs: {
                    model: _vm.articleForm,
                    rules: _vm.articleRules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "文章标题", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入文章标题" },
                        model: {
                          value: _vm.articleForm.title,
                          callback: function($$v) {
                            _vm.$set(_vm.articleForm, "title", $$v)
                          },
                          expression: "articleForm.title"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属频道", prop: "channel_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择频道" },
                          model: {
                            value: _vm.articleForm.channel_id,
                            callback: function($$v) {
                              _vm.$set(_vm.articleForm, "channel_id", $$v)
                            },
                            expression: "articleForm.channel_id"
                          }
                        },
                        _vm._l(_vm.channelOptions, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "文章摘要", prop: "desc" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "请输入文章摘要"
                        },
                        model: {
                          value: _vm.articleForm.desc,
                          callback: function($$v) {
                            _vm.$set(_vm.articleForm, "desc", $$v)
                          },
                          expression: "articleForm.desc"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "封面图片", prop: "cover" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            action: "",
                            "http-request": _vm.onCoverUpload,
                            "show-file-list": false,
                            accept: "image/*",
                            "before-upload": _vm.onBeforeUpload,
                            "on-success": _vm.onCoverUploadSuccess
                          }
                        },
                        [
                          _vm.articleForm.cover
                            ? _c(
                                "div",
                                { staticClass: "article-upload-preview" },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                      "border-radius": "6px"
                                    },
                                    attrs: {
                                      src: _vm.articleForm.cover,
                                      fit: "contain"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "article-upload-placeholder" },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _c("span", [_vm._v("上传封面")])
                                ]
                              )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "正文内容", prop: "content" } },
                    [
                      _c("d2-ueditor", {
                        staticStyle: { "line-height": "1.5" },
                        model: {
                          value: _vm.articleForm.content,
                          callback: function($$v) {
                            _vm.$set(_vm.articleForm, "content", $$v)
                          },
                          expression: "articleForm.content"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推荐文章", prop: "is_recommend" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.articleForm.is_recommend,
                            callback: function($$v) {
                              _vm.$set(_vm.articleForm, "is_recommend", $$v)
                            },
                            expression: "articleForm.is_recommend"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是")
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sort" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "150px" },
                        attrs: { min: 0, precision: 0 },
                        model: {
                          value: _vm.articleForm.sort,
                          callback: function($$v) {
                            _vm.$set(_vm.articleForm, "sort", $$v)
                          },
                          expression: "articleForm.sort"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.articleForm.status,
                            callback: function($$v) {
                              _vm.$set(_vm.articleForm, "status", $$v)
                            },
                            expression: "articleForm.status"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("上架")
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("下架")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.articleDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.articleSubmitLoading },
                  on: { click: _vm.onArticleSubmit }
                },
                [_vm._v("确 认")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.channelForm.id ? "编辑频道" : "新增频道",
            visible: _vm.channelDialogVisible,
            width: "500px",
            "append-to-body": true,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.channelDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "channelForm",
              attrs: {
                model: _vm.channelForm,
                rules: _vm.channelRules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "频道名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入频道名称" },
                    model: {
                      value: _vm.channelForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.channelForm, "name", $$v)
                      },
                      expression: "channelForm.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "150px" },
                    attrs: { min: 0, precision: 0 },
                    model: {
                      value: _vm.channelForm.sort,
                      callback: function($$v) {
                        _vm.$set(_vm.channelForm, "sort", $$v)
                      },
                      expression: "channelForm.sort"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否显示", prop: "is_show" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.channelForm.is_show,
                        callback: function($$v) {
                          _vm.$set(_vm.channelForm, "is_show", $$v)
                        },
                        expression: "channelForm.is_show"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("显示")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("隐藏")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "推荐频道", prop: "is_recommend" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.channelForm.is_recommend,
                        callback: function($$v) {
                          _vm.$set(_vm.channelForm, "is_recommend", $$v)
                        },
                        expression: "channelForm.is_recommend"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.channelDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.channelSubmitLoading },
                  on: { click: _vm.onChannelSubmit }
                },
                [_vm._v("确 认")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }